<script setup>
  const props = defineProps(['isActive']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <button aria-label="menu">
    <IconClose v-if="isActive" />
    <IconHamburger v-else />
  </button>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  button {
    pointer-events: auto;

    position: relative;
    cursor: pointer;

    @include hitbox;

    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
